export interface PricingDefinition {
	title: string;
	definition: string;
	clarifier?: string;
}

export const ListPricingDefinitions: PricingDefinition[] = [
	{
		title: "List Price",
		definition:
			"The published price of a line item without any discounts or promotions. List Price does not include the price of any modifications applied to the line item."
	},
	{
		title: "Modification Price",
		definition: "The additional or discount amount for the modification requested on a line item."
	},
	{
		title: "Adj. List Price",
		definition: "The sum of the List Price and any Modification Prices.",
		clarifier: "(Adjusted List Price)"
	},
	{
		title: "Ext. List Price",
		definition: "The (Adjusted) List Price multiplied by the quantity ordered.",
		clarifier: "(Extended List Price)"
	},
	{
		title: "Subtotal",
		definition:
			"The sum of the Extended List Price for all line items. Subtotal does not include Freight Charge, Tariff Surcharge, Added Order Discounts, Promotions or Estimated Taxes."
	},
	{
		title: "Freight Charge",
		definition: "The chargeable shipping cost."
	},
	{
		title: "Tariff Surcharge",
		definition: "The additional fee to offset the cost of tariffs."
	}
];

export const NetPricingDefinitions: PricingDefinition[] = [
	{
		title: "List Price",
		definition:
			"The published price of a line item before discounts and/or promotions are applied.  List Price does not include the price of any modifications applied to the line item."
	},
	{
		title: "Modification Price",
		definition: "The additional or discount amount for the modification requested on a line item."
	},
	{
		title: "Adj. List Price",
		definition: "The sum of the List Price and any Modification Prices.",
		clarifier: "(Adjusted List Price)"
	},
	{
		title: "Ext. Net Price",
		definition:
			"The (Adjusted) List Price (with the multiplier applied) multiplied by the quantity ordered, before promotions are applied.",
		clarifier: "(Extended Net Price)"
	},
	{
		title: "Promotions & Discounts",
		definition: "The discount amount (with the multiplier applied) on the line item."
	},
	{
		title: "Final Price",
		definition: "The Extended Net Price after any promotion(s) and discounts are applied."
	},
	{
		title: "Adjusted List Total",
		definition: "The sum of the Adjusted List Price for all line items multiplied by the quantities ordered."
	},
	{
		title: "Subtotal",
		definition:
			"The sum of the Final Price for all line items. The Subtotal does not include Freight Charge, Tariff Surcharge, Added Order Charges/Discounts and Estimated Taxes."
	},
	{
		title: "Additional Order Charges/Discounts",
		definition: "The additional promotions, fees, and discounts on the order as a whole."
	},
	{
		title: "Estimated Tax",
		definition: "The preliminary calculation of taxes based on the current details of the order."
	},
	{
		title: "Freight Charge",
		definition: "The chargeable shipping costs."
	},
	{
		title: "Tariff Surcharge",
		definition: "The additional fee to offset the cost of tariffs."
	},
	{
		title: "Net Total",
		definition:
			"The sum of Subtotal, Additional Order Charges/Discounts, Estimated Taxes, Freight Charge and Tariff Surcharge."
	}
];
